import Button from "components/Button/Button";
import React from "react";
import GovernanceStore from "stores/GovernanceStore";
import { GovernanceFormValidations } from "types";

const getSubmitButton = (
  validations: GovernanceFormValidations,
  taxValue?: number,
  depositValue?: number,
  depositAswell?: boolean,
  timeLockChoice?: any
) => {
  if (taxValue && depositValue && depositAswell) {
    return (
      <Button
        type="positive"
        className={`governance-button ${!validations.canDeposit && "disabled"}`}
        onClick={() => GovernanceStore.timelockYGY(depositValue, timeLockChoice.level, taxValue)}
      >
        Timelock <span style={{ fontWeight: "bold" }}>{depositValue.toFixed(2)}</span>YGY for {timeLockChoice.lockTime} weeks
      </Button>
    );
  } else if (taxValue) {
    return (
      <Button type="positive" className={`governance-button`} onClick={() => GovernanceStore.setUserNumber(taxValue)}>
        Propose a <span style={{ fontWeight: "bold" }}>{taxValue}%</span> funding rate.
      </Button>
    );
  }
  return (
    <Button type="positive" className="governance-button disabled">
      Choose your actions
    </Button>
  );
};

export default getSubmitButton;

// const getTaxValueColor = (taxValue: number) => {
//   let value;
//   if (taxValue === 1) value = "rgb(0, 255, 0)";
//   if (taxValue === 2) value = "rgb(120, 240, 0)";
//   if (taxValue === 3) value = "rgb(140, 250, 0)";
//   if (taxValue === 4) value = "rgb(200, 255, 0)";
//   if (taxValue === 5) value = "rgb(255, 255, 0)";
//   if (taxValue === 6) value = "rgb(255, 200, 0)";
//   if (taxValue === 7) value = "rgb(255, 140, 0)";
//   if (taxValue === 8) value = "rgb(255, 0, 0)";
//   return value;
// };
